export const getters = {
  profile: state => state.profile,
};
